import { makeStylesheetLink } from "../stylesheet";

export class SignInCheckout extends HTMLElement {
	shadow: ShadowRoot;
	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button type="button" className="gct-btn-sm gct-btn-secondary">Sign in</button> as HTMLButtonElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			this.button,
			makeStylesheetLink()
		);
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick.bind(this));
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick.bind(this));
	}

}

async function onClick(this: SignInCheckout) {
	const authSection = document.getElementById("auth-section");
	const checkoutSection = document.getElementById("checkout-section");

	if (authSection && checkoutSection) {
		authSection.style.display = "flex";
		checkoutSection.style.display = "none";

		localStorage.setItem("checkoutAsGuest", "false");
	}
}
